// extracted by mini-css-extract-plugin
export default {"container":"UserTypeCard_container__dxUFl"};